import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueFuse from 'vue-fuse'

Vue.use(VueFuse);
Vue.use(VueResource);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js